module.exports = __webpack_public_path__ + "img/jk4.61622252.png";